const NEAR_BLACK = '#141414'
// const NEAR_WHITE = '#F3F3F3'

const styles = {
  appHeader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  romanNumeral: {
    color: NEAR_BLACK,
    fontSize: 100,
    fontWeight: 'bold'
  },
  meditation: {
    color: NEAR_BLACK,
    fontFamily: 'Quicksand-Light',
    fontSize: 30.9, 
  },
  spacer: {
    height: 125
  }
}

export default styles